export default __webpack_public_path__ + "static/media/Ballroll_00137.a19a24af.png";